import * as React from "react";
import { FormControl, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Project } from "../../../api/graphQL/queryModels";

interface ProjectFieldProps {
    options: Project[];
    loading: boolean;
    selectedId: number | null;
    onChange: (selectedId: number | null) => unknown;
    disabled?: boolean;
}

const ProjectField = (props: ProjectFieldProps) => {
    const { options, selectedId, loading, disabled } = props;

    return (
        <FormControl variant="outlined" fullWidth>
            <Autocomplete
                loading={loading}
                value={selectedId && options.length ? selectedId : null}
                options={options.map((o) => o.id)}
                getOptionLabel={(value) => {
                    const option = options.find((p) => p.id === value);
                    return option ? option.name : ""; // Use a fallback value if 'option' is undefined
                }}
                onChange={(event: unknown, newValue: number | null) => {
                    props.onChange(newValue || null);
                }}
                disabled={disabled}
                fullWidth
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Project" placeholder="Project" size="small" fullWidth />
                )}
            />
        </FormControl>
    );
};

export default ProjectField;
